import CourseController from '../diagrams/course.controller';

class HighlightDiagramController extends CourseController {

  constructor(courseService, diagramService, $translate, $timeout, $sce, audioService, $scope) {
    'ngInject';

    super(courseService, diagramService, $translate, $scope);

    this.$timeout = $timeout;
    this.$sce = $sce;
    this.answers = 0;
    this.audioService = audioService;
    this.isHighlight = true
  }

  $onInit() {
    this.diagramId = '' + this.data.diagramId;
    this.clearDiagramId = '' + this.data.diagramId;
    if (this.data.example) {
      this.diagramComplete = true;
    }
    this.amountCorrectAnswers = this.data.answers.split(' ').length
    super.$onInit()
  }

  submit() {
    this.submitCount++;
    this.submited = true;
    const answers = $(`#${this.diagramId} .highlight__answer`);

    const answersArr = [];
    Array.from(answers).forEach(element => {
      answersArr.push(element.textContent);
    });
    const currAnswer = answersArr.join(' ');

    if (this.data.answers === currAnswer) {
      this.audioService.play('buttonClick');
      this.diagramComplete = true;
      this.audioService.play('exerciseComplete');
      this.finishExercise();
    } else {
      this.audioService.play('wrongAnswer');
    }
  }

  correct(){
    this.hintCount++;
    this.audioService.play('buttonClick');
    this.diagramComplete = true;
    this.finishExercise();
  }

  toggleAnswer($event) {
    $($event.currentTarget).hasClass('highlight__answer') ? this.answers-- : this.answers++;
    $($event.currentTarget).toggleClass('highlight__answer');
  }

  renderTask(task) {
    return this.$sce.trustAsHtml(task);
  }


}

export default HighlightDiagramController;



// WEBPACK FOOTER //
// ./client/app/components/highlight-diagram/highlight-diagram.controller.js